import React from 'react'

const ThankyouPageIndividual = () => {
    return (
        <div className="max-w-3xl mx-auto my-10 p-8 bg-white rounded-xl shadow-lg">
            {/* Header */}
            <div className="bg-gradient-to-r from-green-400 to-green-600 text-white text-center py-8 px-6 rounded-t-xl">
                <h1 className="text-2xl md:text-3xl font-bold mb-2">
                    Assessment Submitted Successfully!
                </h1>
                <p className="opacity-90">Thank you for completing the assessment</p>
            </div>

            {/* Content */}
            <div className="p-6">
                {/* Greeting */}
                <h2 className="text-xl font-semibold text-gray-800 mb-6">
                    Thank You for Your Participation,
                </h2>

                {/* Completion Message */}
                <div className="bg-green-50 border-l-4 border-green-500 p-5 rounded-r-lg mb-8">
                    <h3 className="text-lg font-semibold text-green-700 mb-3">
                        Your assessment has been received
                    </h3>
                    <ul className="space-y-3 list-disc pl-5 text-gray-700 text-start">
                        <li>
                            Your responses have been{" "}
                            <span className="font-medium">successfully submitted</span> and
                            recorded
                        </li>
                        <li>The results will be reviewed by our team</li>
                    </ul>
                </div>

                {/* Next Steps */}
                <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-r-lg mb-8">
                    <h3 className="text-lg font-semibold text-blue-700 mb-3">
                        What Happens Next?
                    </h3>
                    <ul className="space-y-2 list-disc pl-5 text-gray-700 text-start">
                        <li>Our team will review your assessment</li>
                        <li>Your assessment results will be available under the Assessment Results tab after 15 minutes.</li>
                    </ul>
                </div>

                {/* Close Button */}
                {/* <div className="text-center mt-10">
          <button
            // onClick={() => navigate("/")} // or wherever you want to navigate
            className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            Return to Dashboard
          </button>
          <p className="text-gray-500 text-sm mt-3">
            You may now safely close this window
          </p>
        </div> */}
            </div>

            {/* Footer */}
            <div className="bg-green-50 text-center py-4 rounded-b-xl text-sm text-gray-600">
                {/* <p>
          Need help?{" "}
          <a
            href="mailto:support@selfsync.ai"
            className="text-green-600 font-medium"
          >
            Contact support
          </a>
        </p> */}
                <p className="mt-1">
                    © {new Date().getFullYear()} mytruestrength.com All rights reserved.
                </p>
            </div>
        </div>
    )
}

export default ThankyouPageIndividual